import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/loginRegister/notice.png'
import _imports_1 from '@/assets/themeFour/CPF.png'
import _imports_2 from '@/assets/deposit/deposit_bonus.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "deposit_container" }
const _hoisted_3 = { class: "custom_theme_tabs" }
const _hoisted_4 = { class: "tab_title_box" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "bonus_select" }
const _hoisted_8 = { class: "deposit_notice" }
const _hoisted_9 = { class: "sub_container" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "input_field" }
const _hoisted_12 = { class: "right-wrapper" }
const _hoisted_13 = {
  key: 0,
  class: "errorText"
}
const _hoisted_14 = {
  key: 2,
  class: "descriptionContainer"
}
const _hoisted_15 = { class: "noticeText" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }

import { onMounted, ref, watch } from 'vue';
import InputField from './components/inputField.vue';
import AmountCard from './components/amountCard.vue';
import { PayChannel } from '@/types/common';
import { formatCurrency } from '@/utils/commonFunction';
import { useUserStore } from '@/stores/user';
import { DepositData } from '@/view/deposit/supportScript';
import MainButton from '../../themeFour/components/common/mainButton.vue';
import CustomHeader from '../components/common/customHeader.vue';
import DepositTopCard from '../components/common/topHeaderCard.vue';
import { useRouter } from 'vue-router';
import ErcCard from '@/themes/themeFour/deposit/components/ercCard.vue';
import QRPage from './components/QRPage.vue';
import MainFooter from '../components/common/mainFooter.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'depositView',
  props: {
    dataSet: {},
    isComponentUse: { type: Boolean }
  },
  emits: ['selectChannel', 'updateSelecTopup', 'updateSelectedAmount', 'updateCpfID', 'selectAmountCard', 'confirmDeposit'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const selecTopup = ref(props.dataSet.selecTopup)
const selectedAmount = ref(props.dataSet.selectedAmount)
const footerSelected = localStorage.getItem('showDepositBackIcon')
const amountValue = ref()
const cpfID = ref(props.dataSet.cpfID)
const userStore = useUserStore()
const router = useRouter()
const emit = __emit
const activeTab = ref(0);
const display_qr = ref(false);
const selectChannel = (item: PayChannel) => {
    emit('selectChannel', item)
}
watch(selecTopup, (val) => {
    emit('updateSelecTopup', val)
})
watch(selectedAmount, (val) => {
    emit('updateSelectedAmount', val)
})
watch(cpfID, (val) => {
    emit('updateCpfID', val)
})
watch(() => props.dataSet, (newVal) => {
    selectedAmount.value = newVal.selectedAmount
}, { deep: true, immediate: true })

const selectAmountCard = (select: any) => {
    selectedAmount.value = select.fillValue
    emit('selectAmountCard', select)
}
const confirmDeposit = () => {
    emit('confirmDeposit')
}
const onClear = () => {
    cpfID.value = ''
}
const backNavigate = () => {
    userStore.setRechargeBonusType(0)
    userStore.setTakeFirstDeposit(false)
    router.go(-1)
    localStorage.setItem('showDepositBackIcon', '0')
}
const goToFund = () => {
    router.replace({ path: '/fundsHistory', query: { tabIndex: 0 } })
}
const iframeUrl = ref('')
const triggerConfirm = (url: string) => {
    display_qr.value = true
    iframeUrl.value = url
    amountValue.value = selectedAmount.value
}

const handleTabClick = (tabObject: any) => {
    const id = tabObject.name;
    const selected = props.dataSet.channelList.find(item => String(item.id) === String(id));
    if (selected) {
        emit('selectChannel', selected);
    }
};
onMounted(() => {
    const footerPopupOpen = localStorage.getItem('footerPopupOpen')
    if (footerPopupOpen == '2') {
       localStorage.setItem('showDepositBackIcon', '0')
    }
})
__expose({
    triggerConfirm
})


return (_ctx: any,_cache: any) => {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!display_qr.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(DepositTopCard, {
            text: _ctx.$t('common.deposite'),
            "sub-text": _ctx.$t('common.subText'),
            onClosePopup: backNavigate,
            "show-fund": true,
            onGoToFund: goToFund,
            hideBacKIcon: _unref(footerSelected) != '1'
          }, null, 8, ["text", "sub-text", "hideBacKIcon"]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"height":"150px","background-color":"#024A49","border-bottom-left-radius":"10px","border-bottom-right-radius":"10px"} }, null, -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('common.paymentChannel')), 1),
              _createVNode(_component_van_tabs, {
                "model-value": props.dataSet.activeChannel.id,
                class: "inner_channel_tabs",
                border: false,
                type: "card",
                onClickTab: handleTabClick,
                "swipe-threshold": "4"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.channelList, (item) => {
                    return (_openBlock(), _createBlock(_component_van_tab, {
                      key: item.id,
                      title: item.name,
                      name: item.id
                    }, null, 8, ["title", "name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["model-value"])
            ]),
            (props.dataSet.activeChannel.channelType == '3' || props.dataSet.activeChannel.channelType == '4' || props.dataSet.activeChannel.channelType == '5')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(ErcCard, {
                    address: props.dataSet.ercCode,
                    minAmount: props.dataSet.minErcAmount,
                    maxAmount: props.dataSet.maxErcAmount,
                    typeTitle: props.dataSet.activeChannel.name
                  }, null, 8, ["address", "minAmount", "maxAmount", "typeTitle"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_van_checkbox, {
                      modelValue: selecTopup.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selecTopup).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('deposit.promotions')), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: ""
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('deposit.bonuseRedeem')) + " " + _toDisplayString(_ctx.dataSet.turnOverValue) + "x " + _toDisplayString(_ctx.$t('deposit.invoicing')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(InputField, {
                      modelValue: selectedAmount.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedAmount).value = $event)),
                      labelText: _ctx.dataSet.min_amount + ' - ' + _ctx.dataSet.max_amount,
                      isTopupVisible: selecTopup.value,
                      giftAmount: _ctx.dataSet.giftAmount
                    }, null, 8, ["modelValue", "labelText", "isTopupVisible", "giftAmount"]),
                    (_ctx.dataSet.activeChannel.channelType == '7' || _ctx.dataSet.activeChannel.channelType == '2')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "inputLabel" }, "CPF ID", -1)),
                            _createVNode(_component_van_field, {
                              modelValue: cpfID.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cpfID).value = $event)),
                              type: "number",
                              placeholder: _ctx.$t('withdraw.cpfIdPlaceholder')
                            }, {
                              "left-icon": _withCtx(() => _cache[5] || (_cache[5] = [
                                _createElementVNode("div", { class: "left-wrapper" }, [
                                  _createElementVNode("img", {
                                    src: _imports_1,
                                    alt: "CPF",
                                    class: "cpf-icon"
                                  })
                                ], -1)
                              ])),
                              "right-icon": _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                  (cpfID.value)
                                    ? (_openBlock(), _createBlock(_component_van_icon, {
                                        key: 0,
                                        name: "clear",
                                        class: "custom-clear",
                                        onClick: _withModifiers(onClear, ["stop"])
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ]),
                          (_ctx.dataSet.showCPFIdError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('withdraw.cpfErrorText')), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_van_row, { class: "amount_card_list" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.amountList, (item) => {
                          return (_openBlock(), _createBlock(_component_van_col, {
                            span: "8",
                            key: item.fillValue,
                            style: {"padding":"5px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(AmountCard, {
                                amount: item.fillValue,
                                isActiveAmount: _ctx.dataSet.selectedAmount == item.fillValue,
                                giftRatio: item.giftRatio,
                                isTopupVisible: selecTopup.value,
                                onHandleCardClick: ($event: any) => (selectAmountCard(item))
                              }, null, 8, ["amount", "isActiveAmount", "giftRatio", "isTopupVisible", "onHandleCardClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    (selecTopup.value)
                      ? (_openBlock(), _createBlock(_component_van_row, {
                          key: 1,
                          class: "note_text"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_col, { span: "4" }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createElementVNode("img", {
                                  src: _imports_2,
                                  alt: ""
                                }, null, -1)
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_van_col, { span: "20" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.deposite')) + " R$ " + _toDisplayString(_unref(formatCurrency)(selectedAmount.value)) + " " + _toDisplayString(_ctx.$t('deposit.receive')) + " R$ " + _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.giftAmount)) + " " + _toDisplayString(_ctx.$t('deposit.asaGift')) + ".", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(userStore).isEnableRechargeNotice && _ctx.dataSet.activeChannel.rechargeNotice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('common.notice')), 1),
                          _createElementVNode("div", {
                            innerHTML: _ctx.dataSet.activeChannel.rechargeNotice
                          }, null, 8, _hoisted_16)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn_container", { 'with-footer': _unref(footerSelected) != '1' }])
                  }, [
                    _createVNode(MainButton, {
                      title: _ctx.$t('common.deposite'),
                      activeStatus: _ctx.dataSet.isFillField,
                      onClick: confirmDeposit,
                      radius: '8px',
                      "btn-padding": '28px'
                    }, null, 8, ["title", "activeStatus"])
                  ], 2)
                ]))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(QRPage, {
            show: display_qr.value,
            iframeUrl: iframeUrl.value,
            selectedAmountVal: amountValue.value,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (display_qr.value = false)),
            onGoTo: goToFund
          }, null, 8, ["show", "iframeUrl", "selectedAmountVal"])
        ])),
    (_unref(userStore).footerComponent && _unref(footerSelected) != '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(MainFooter, {
            itemData: _unref(userStore).footerComponent,
            activeFooter: 2
          }, null, 8, ["itemData"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})